import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import './PlayersStatistics.css';
import { getStatisticsForCompetition } from '../util/api_calls/ProjectApiCalls';

class PlayersStatistics extends Component {

  constructor(props) {
    console.log('[PlayersStatistics.js] constructor called', props);
    super(props);
    this.state = {
        idCompetition: props.idCompetition,
        showInPercents: props.showInPercents,
        fontColor: props.fontColor,
        backgroundColor: props.backgroundColor
    }
  }

  componentDidMount() {
    getStatisticsForCompetition(this.state.idCompetition, 
        (successData) => {
            console.log('Statistics retrieved', successData);
            this.setState({
                statistics: successData.data.data
            })
        },
        (errorData) => {
            console.error(errorData);
        })
  }

  rowNumberSuffix = function(rowNumber) {
    //We don't expect real world scenario in which this function will be called for argument greater than 100
    if(rowNumber == 11 || rowNumber == 12 || rowNumber == 13) {
        return 'th';
    }
    if(rowNumber % 10 === 1) {
        return 'st';
    } else if(rowNumber % 10 === 2) {
        return 'nd';
    } else if(rowNumber % 10 === 3) {
        return 'rd';
    } else {
        return 'th'
    }
  }

  render() {
    console.log('PlayersStatistics.js render', this.state);
    if(!this.state.statistics) {
        return null;
    }

    return (
      <div className={'statisticsContentPlaceholder'}>
        <h2 style={{ textAlign: 'center', textTransform: 'uppercase'}}><b>Most popular votes</b></h2>
        {this.state.statistics.map(statWrapperByLine => {
            return (
                <div key={statWrapperByLine.lineId}>
                    <h3 style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '16px', fontWeight: '700'}}>{statWrapperByLine.lineName}</h3>
                    <div className={'statisticsContainerForLine'}>
                        {
                            statWrapperByLine.statistics.map((stat, index) => {
                                const value = this.state.showInPercents ? (stat.percent.toFixed(2) + '%') : (stat.numberOfVotes + ' votes')
                                return (
                                    <div key={stat.headshotSmall} className={'particularPlayerStatisticsHolder'}>
                                        <span style={{textAlign: 'center'}}>{(index + 1) + this.rowNumberSuffix(index + 1)}</span>
                                        <div style={{ textAlign: 'center'}}>
                                            <img src={stat.headshotSmall} style={{ height: '150px' }} />
                                        </div>
                                        <span style={{ wordWrap: 'break-word', fontSize: '12px', textAlign: 'center'}}>{stat.firstname + ' ' + stat.lastname}</span>
                                        <span style={{ fontSize: '13px', textAlign: 'center'}}>{value}</span>
                                    </div>
                                )  
                            })
                        }
                    </div>
                </div>
            );
        })}
      </div>
    );
  }
}

export default PlayersStatistics;
